export const useStyles = (theme) => ({
  root: {
    padding: 20,
    minHeight: "50vh",
    display: "flex",
    flexDirection: "column",
    fontSize: 24,
    justifyContent: "center",
    alignItems: "center",
    fontWeight: "bold",
  },
  buttonStyle: {
    background: "#0a1f3a !important",
    outlineColor: "#0a1f3a !important",
    color: "#ffffff",
    fontSize: 18,
    borderRadius: 20,
    textTransform: "none",
    marginRight: 10,
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#0a1f3a !important",
      color: "#181818",
    },
  },
  imageStyle: {
    width: 700,
    height: 500,
    [theme.breakpoints.down(960)]: {
      width: 200,
      height: 200,
    },
  },
});
